import {request} from "./request";
import Axios from "axios";

export function upLoadTeachers(data) {
  return request({
    url: 'uploader/teachers',
    method: 'post',
    // headers: {
    //   'Content-Type': 'multipart/form-data'
    // },
    data: data
  })
}

export function upLoadStudents(data) {
  return request({
    url: 'uploader/students',
    method: 'post',
    // headers: {
    //   'Content-Type': 'multipart/form-data'
    // },
    data: data
  })
}

export function upLoadStuScore(data) {
  return request({
    url: 'uploader/StuScore',
    method: 'post',
    // headers: {
    //   'Content-Type': 'multipart/form-data'
    // },
    data: data
  })
}

export function getToken() {
  return request({
    url: 'uploader/token',
    contentType: false,
  })
}

export function upLoadImageToQiNiu(data) {
  const axiosInstance = Axios.create({withCredentials: false});    //withCredentials 禁止携带cookie，带cookie在七牛上有可能出现跨域问题
  return axiosInstance({
    method: 'POST',
    url: 'http://up-z1.qiniup.com/',  //上传地址
    data: data,
    timeout: 30000,      //超时时间，因为图片上传有可能需要很久
    // onUploadProgress: (progressEvent) => {
    //   //imgLoadPercent 是上传进度，可以用来添加进度条
    //   let imgLoadPercent = Math.round(progressEvent.loaded * 100 / progressEvent.total);
    // },
  });
}

export function upLoadStuPhysicalTest(data) {
  return request({
    url: 'uploader/upLoadStuPhysicalTest',
    method: 'post',
    data: data
  })
}

export function upLoadStuSportsMeet(data) {
  return request({
    url: 'uploader/upLoadStuSportsMeet',
    method: 'post',
    data: data
  })
}

export function upLoadCourseScore(data) {
  return request({
    url: 'uploader/upLoadCourseScore',
    method: 'post',
    data: data
  })
}
